'use client'

import { getFavoriteItems } from '@/lib/like'
import type { serviceType } from '@/lib/service/server'
import { faHeart } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'

type CartIconProps = {
  service: serviceType
}

export const HeartIconClient: React.FC<CartIconProps> = ({ service }) => {
  const [count, setCount] = useState(0)
  useEffect(() => {
    let cancelled = false
    getFavoriteItems(service.service_id)
      .then((items) => {
        if (!cancelled) setCount(items?.length ?? 0)
      })
      .catch(() => {
        if (!cancelled) setCount(0)
      })
    return () => {
      cancelled = true
    }
  }, [service.service_id])
  return (
    <div className="w-full relative">
      <FontAwesomeIcon icon={faHeart} fontSize={'20px'} className="" />
      <span
        className="absolute rounded-full bg-red-500 text-white text-xs px-1"
        style={{ right: '-6px', top: '-4px' }}
      >
        {count}
      </span>
    </div>
  )
}
